import React from "react";
import type { InteractionDialogProps } from "../DialogBase";
import { DialogBase } from "../DialogBase";
import { onCloseDialog } from "../util";
import { InteractionButtons } from "./InteractionButtons";

export const Destructive = ({
  ariaLabel,
  title,
  onClose,
  open,
  children,
  ariaLabelCloseIcon,
  onDismissFocusRef,
  icon,
  illustration,
  dataTestId,
  hideCloseButton,
  width,
  alignIllustration,
  dialogAlignment,
  drawerSize,
  ...interactionProps
}: InteractionDialogProps): React.JSX.Element | null => {
  const closeHandler = (): void =>
    onCloseDialog({ onDismissFocusRef, onClose });

  if (!open) {
    return null;
  }

  return (
    <DialogBase
      ariaLabel={ariaLabel}
      alignIllustration={alignIllustration}
      onDismissFocusRef={onDismissFocusRef}
      open={open}
      title={title}
      onClose={closeHandler}
      ariaLabelCloseIcon={ariaLabelCloseIcon}
      icon={icon}
      illustration={illustration}
      dataTestId={dataTestId}
      hideCloseButton={hideCloseButton}
      width={width}
      dialogAlignment={dialogAlignment}
      drawerSize={drawerSize}
    >
      {children}
      <InteractionButtons
        type="destructive"
        onClose={closeHandler}
        onConfirm={interactionProps.onConfirm}
        onCancel={interactionProps.onCancel ?? closeHandler}
        actionText={interactionProps.actionText}
        actionDisabled={interactionProps.actionDisabled}
        cancelText={interactionProps.cancelText}
        actionIcon={interactionProps.actionIcon}
      />
    </DialogBase>
  );
};
